"use client";

/**
 * Hook that returns page sections (all components except navbar)
 * Replaces the repeated `components.filter(c => c.type !== "navbar")` pattern
 */

import { useMemo } from "react";
import { useBuilderStore } from "../_stores/builder-store";
import type { PageComponent } from "../_types";

/**
 * Returns memoized array of section components (excludes navbar)
 * @returns Filtered array of PageComponent excluding navbar type
 */
export function useSections(): PageComponent[] {
  const components = useBuilderStore((s) => s.components);
  return useMemo(() => components.filter((c) => c.type !== "navbar"), [components]);
}
